module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-2-43917d2ff8b777c0533272956992c09b.jpg";